import { Locales } from "@/types/locales/locales"
import { Applications } from "@/types/application/applications"

export default class GlobalState {
  public isDarkTheme: boolean | null = null
  public languageCode: Locales | null = null
  public application: Applications | null = null
}
